import { useState, useEffect } from 'react';
import './supOrgAccEdit.css';
import DirectInput from '../../components/directInput/DirectInput';
import Owner from './orgRegSections/owner/Owner';
import CompanyDetails from './orgRegSections/company/CompanyDetails';
import ContactPerson from './orgRegSections/contactPerson/ContactPerson';
import CompanyAddress from './orgRegSections/address/CompanyAddress';
import BankCompany from './orgRegSections/bank/BankCompany';
import { useNavigate, useParams } from 'react-router-dom';
import orgRegSubmit, { orgStatusEdit } from './orgRegFun/orgRegSubmit';
import ReactLoading from 'react-loading';
import { FetchOrgAccount } from '../supOrgAccount/orgAccountFun/fetchOrgAccount';
import errorHandle from '../../utils/errorHandle';
import GoogleRating from './orgRegSections/googleRatings/GoogleRating';
import Percentage from './orgRegSections/percentage/Percentage';
import { getModeOrg, getTypeOrg } from '../../utils/getType';

export default function SupOrgAccEdit() {
    const typeDrop = ['Trip', 'Guide', 'Camp', 'Activity'];
    const { orgId, mode } = useParams();
    const type = 'trip';
    const [formData, setFormData] = useState({
        type: getTypeOrg(mode),
        typeTemp: getModeOrg(mode),
        companyName: '',
        owner: [
            {
                name: '',
                designation: '',
                phoneNumber: '',
                countryCode: '',
                emailId: '',
                identityProof: '',
                identityProofNum: ''
            }
        ],
        razorFundAccountId: '',
        address: {
            name: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            pincode: '',
            state: '',
            country: ''
        },
        typeofCompany: 'Select',
        about: '',
        logo: null,
        gst: '',
        cin: '',
        status: '',
        countryCode: '',
        //This phone will used to login and access the account. this phone will be used for all the phone communications
        phoneNumber: '',
        //This emailID will used to login and access the account. this email will be used for all the email communications
        emailId: '',
        // password: '',

        quickView: {
            where: '',
            food: '',
            baseCities: ''
        },
        FAQ: [{ question: '', answer: '' }],
        tags: [],

        contactPerson: {
            name: '',
            phoneNumber: '',
            countryCode: '',
            emailId: ''
        },
        googleRating: '',
        googleRaCount: '',
        bank: {
            bankName: '',
            accName: '',
            branchName: '',
            accNum: '',
            ifsc: ''
        },
        webCom: 0,
        orgWeb: 0,
        othWeb: 0
    });
    const navigate = useNavigate();
    const [accDetails, setAccDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [logoData, setLogoData] = useState();
    const [accRe, setAccRe] = useState('');
    const [tempData, setTempData] = useState({
        included: '',
        excluded: '',
        terms: '',
        safety: '',
        carry: ''
    });
    const [imgData, setImgData] = useState({
        oldWallImg: [],
        oldThumbImg: [],
        newWallImg: [],
        newThumbImg: []
    });
    const [videoFile, setVideoFile] = useState(null);

    async function fetchAccData() {
        setLoading(true);
        try {
            const data = await FetchOrgAccount({ type: getTypeOrg(mode), orgId }); // return the data
            setAccDetails(data);
            console.log(data, 'data');

            setFormData((prev) => ({
                ...prev,
                about: data.about || '',
                address: { ...prev.address, ...data.address },
                bank: { ...prev.bank, ...data.bank },
                cin: data.cin || '',
                companyName: data.companyName || '',
                contactPerson: { ...prev.contactPerson, ...data.contactPerson },
                countryCode: data.countryCode || '',
                emailId: data.emailId || '',
                gst: data.gst || '',
                logo: data.logo || '',
                status: data.status || '',
                googleRating: data.googleRating || '',
                googleRaCount: data.googleRaCount || '',
                razorFundAccountId: data.razorFundAccountId || '',
                owner: data.owner?.length ? data.owner : prev.owner,
                phoneNumber: Array.isArray(data.phoneNumber) ? data.phoneNumber[0] : data.phoneNumber || '',
                typeofCompany: data.typeofCompany || 'Select',
                webCom: data?.webCom ?? 0,
                orgWeb: data?.orgWeb ?? 0,
                othWeb: data?.othWeb ?? 0
            }));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }

    useEffect(() => {
        fetchAccData();
    }, [orgId]);

    function getDiffDotNotation(original, updated, parentKey = '', result = {}) {
        for (const key in updated) {
            const fullKey = parentKey ? `${parentKey}.${key}` : key;

            const updatedValue = updated[key];
            const originalValue = original?.[key];

            if (typeof updatedValue === 'object' && updatedValue !== null && !Array.isArray(updatedValue)) {
                getDiffDotNotation(originalValue || {}, updatedValue, fullKey, result);
            } else if (Array.isArray(updatedValue)) {
                if (JSON.stringify(updatedValue) !== JSON.stringify(originalValue)) {
                    result[fullKey] = updatedValue;
                }
            } else {
                if (updatedValue !== originalValue) {
                    result[fullKey] = updatedValue;
                }
            }
        }

        return result;
    }

    async function handleSubmit() {
        const diff = getDiffDotNotation(accDetails, formData);
        console.log(diff);
        try {
            // type tells the backend which organizer collection to update
            const res = await orgRegSubmit(
                { _id: accDetails._id, ...diff, type: getTypeOrg(mode) },
                setLoading,
                accRe,
                logoData
            );
            if (res.status === 200) {
                navigate(`/support/${mode}/org/account/${accDetails._id}`);
            }
        } catch (error) {
            console.error('Registration failed:', error);
        }
    }

    async function handleActive() {
        try {
            const res = await orgStatusEdit(
                {
                    _id: accDetails._id,
                    type: getTypeOrg(mode),
                    status: accDetails.status === 'active' ? 'inactive' : 'active'
                },
                setLoading
            );
            if (res.status === 200) {
                fetchAccData();
            }
        } catch (error) {
            console.error('Status change failed:', error);
        }
    }
    function handleTypeDrop(e) {
        if (e.target.value === 'Trip') {
            setFormData((prevState) => {
                return { ...prevState, type: 'trip', typeTemp: 'Trip' };
            });
        }
        if (e.target.value === 'Guide') {
            setFormData((prevState) => {
                return { ...prevState, type: 'gu', typeTemp: 'Guide' };
            });
        }
        if (e.target.value === 'Camp') {
            setFormData((prevState) => {
                return { ...prevState, type: 'camp', typeTemp: 'Camp' };
            });
        }
        if (e.target.value === 'Activity') {
            setFormData((prevState) => {
                return { ...prevState, type: 'act', typeTemp: 'Activity' };
            });
        }
    }
    console.log(formData);
    return (
        <>
            <div className='orgRegisterDiv'>
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                )}

                {/* Information of organizer to be filled */}
                <div>
                    <div className='flex justify mb-2'>
                        <h2 className='orgRegisterH1'>Organizer Edit</h2>
                        <button
                            className='orgAccEditBtn blueBtn'
                            onClick={() => {
                                handleActive();
                            }}
                        >
                            {formData.status === 'active' ? 'Deactivate account' : 'Activate account'}
                        </button>
                    </div>
                    <div className='orgRegisterSecDiv'>
                        <div className='dropRegDiv'>
                            <label className='dropRegLabel'>Type</label>
                            <div className='dropRegInputDiv'>
                                <select
                                    value={formData.typeTemp}
                                    name='type'
                                    onChange={(e) => handleTypeDrop(e)}
                                    required={true}
                                    className='dropRegSelect'
                                    disabled
                                >
                                    <option value='-1'>Select</option>
                                    {typeDrop.map(function (val, typeIndex) {
                                        return (
                                            <option key={typeIndex} value={val}>
                                                {val}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <DirectInput
                            label='Company Name'
                            name='companyName'
                            value={formData.companyName}
                            setFormData={setFormData}
                            type='text'
                            placeholder='Name of the company'
                            min={3}
                            limit={70}
                        />
                    </div>
                    <Owner formData={formData} setFormData={setFormData} />
                    <CompanyDetails
                        formData={formData}
                        setFormData={setFormData}
                        logoData={logoData}
                        setLogoData={setLogoData}
                        // conPass={conPass}
                        // setConPass={setConPass}
                    />
                    <CompanyAddress formData={formData} setFormData={setFormData} />
                    <ContactPerson formData={formData} setFormData={setFormData} />
                    <BankCompany formData={formData} setFormData={setFormData} accRe={accRe} setAccRe={setAccRe} />
                    <GoogleRating formData={formData} setFormData={setFormData} />
                    <Percentage formData={formData} setFormData={setFormData} />
                    <div style={{ marginTop: 30 }} className='orgRegisterSecDiv'>
                        <DirectInput
                            label='Razorpay Account Id'
                            name='razorFundAccountId'
                            value={formData.razorFundAccountId}
                            setFormData={setFormData}
                            type='text'
                            placeholder='Razorpay Fund Account Id'
                            min={3}
                            limit={70}
                        />
                    </div>
                </div>
                <button type='button' className='orgRegisterSubmitBtn blueBtn' onClick={handleSubmit}>
                    Submit
                </button>
            </div>
        </>
    );
}
